import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'
import styles from '../../../styles/bantrab/components/card.module.scss'

import Icon from '../icon/index'
import Time from '../icon/time.svg'
import Play from '../icon/playcircle.svg'
import ArrowDown from '../icon/chevron-down.svg'

const Dropdown = ({ title, textContent, time, classes, arrowId, content, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.dropdown]: true
  })

  return (
    <div {...attrs}>
      <div className="w-72 p-4 rounded-2xl rounded-tl-none sm:p-6 shadow-md">
        <div className="sm:flex">
          <figure className="rounded-2xl rounded-tl-none w-full"></figure>
          <div className="mt-6 sm:mt-0 sm:ml-6">
            {/* <h1 className="">{title}</h1> */}
            <Typography tag={'h2'} size="three" weight="bold">
              {title}
            </Typography>
            <Typography tag="h3" size="three" className="mt-4">
              {textContent}
            </Typography>
            <div className="mt-4 flex">
              <div className="flex items-center">
                <Icon svg={Time} size={16} />
                <Typography tag="p" size="two" className="ml-2">
                  {time}
                </Typography>
              </div>
              <div className="ml-6 flex items-center">
                <Icon svg={Play} size={16} />
                <Typography tag="p" size="two" className="ml-2">
                  {classes}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <input id={arrowId} type="checkbox" />
        <label htmlFor={arrowId} className="mt-6 flex items-center cursor-pointer">
          <Typography tag="h2" size="three" className="mr-3">Mostrar contenido</Typography>
          <Icon svg={ArrowDown} size={24} />
        </label>
        <div>
          <ul>
            {
              content.map((item, index) => {
                return (
                  <li className="flex items-start relative" key={index}>
                    <div className="flex flex-col items-center absolute top-2">
                      <div className="w-2 h-2 rounded-lg"></div>
                      <div></div>
                    </div>
                    <div className="ml-6">
                      <Typography tag="h3" size="three" weight="bold">{item.title}</Typography>
                      <Typography tag="p" size="three">{item.time}</Typography>
                    </div>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    </div>
  )
}

Dropdown.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  classes: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  arrowId: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default Dropdown
